(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v7"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var initDraggablePointerSlider = function() {
    jQuery('.momuko-product-slider-row').each(function() {
      var $scrollRow = jQuery(this);
      var rowEl = $scrollRow[0];
      var $parentBlock = $scrollRow.closest('.momuko-slider-layout-box');
      var $pointerInput = $parentBlock.find('.momuko-scrollbar-pointer');
      
      if (!$scrollRow.hasClass('momuko-scrollbar-bound')) {
        $scrollRow.addClass('momuko-scrollbar-bound');

        // 1. Two-way binding function: Sync the pointer position when a user swipes items
        var syncPointerWithRowScroll = function() {
          var scrollLeft = rowEl.scrollLeft;
          var maxScrollLeft = rowEl.scrollWidth - rowEl.clientWidth;
          
          if (maxScrollLeft <= 0) {
            $pointerInput.val(0);
            return;
          }
          
          // Map position to a 0-100 range scale value
          var percentageValue = (scrollLeft / maxScrollLeft) * 100;
          $pointerInput.val(percentageValue);
        };

        // 2. Two-way binding function: Scroll items when a shopper drags the pointer thumb
        var syncRowScrollWithPointerInput = function() {
          var currentVal = parseFloat($pointerInput.val()) || 0;
          var maxScrollLeft = rowEl.scrollWidth - rowEl.clientWidth;
          
          var targetScrollPosition = (currentVal / 100) * maxScrollLeft;
          rowEl.scrollLeft = targetScrollPosition;
        };

        // Attach native browser listeners for 100% responsive handling
        rowEl.addEventListener('scroll', syncPointerWithRowScroll, { passive: true });
        
        // Listen to both inputs and change sweeps for cross-browser live dragging updates
        $pointerInput.on('input change', syncRowScrollWithPointerInput);
        
        // Initial setup execution loop check
        window.addEventListener('resize', syncPointerWithRowScroll, { passive: true });
        setTimeout(syncPointerWithRowScroll, 300);

        // Navigation arrow click updates
        $parentBlock.find('.v7-prev-btn').on('click', function(e) {
          e.preventDefault();
          var itemWidth = $scrollRow.find('.product_item').first().outerWidth(true) || 280;
          rowEl.scrollLeft -= itemWidth;
          setTimeout(syncPointerWithRowScroll, 150);
        });
        
        $parentBlock.find('.v7-next-btn').on('click', function(e) {
          e.preventDefault();
          var itemWidth = $scrollRow.find('.product_item').first().outerWidth(true) || 280;
          rowEl.scrollLeft += itemWidth;
          setTimeout(syncPointerWithRowScroll, 150);
        });
      }
    });
  };

  initDraggablePointerSlider();

  // Watch section refreshes within the live theme customized editor dashboard space
  document.addEventListener('shopify:section:load', function() {
    initDraggablePointerSlider();
  });
});

  } catch(e) { console.error(e); }
})();
})();
